import React from 'react';
import {
    withStyles,
    Grid,
    ListItem,
    ButtonBase,
    Typography,
    Snackbar,
} from '@material-ui/core';

import {
    withRouter,
} from "react-router-dom"

import MBack from '../view/MBack';
import Apis from '../../network/Apis';
import AppUtils from '../../control/apputlis';

const ICON_ATTION = require("../../images/icons/attention.png");


class IntegralAddress extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            phone: '',
            address: '',
            postcode: '',
            name: '',
            message: '',
            snackopened: false,
        };
    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'IntegralAddress');
    }

    componentWillUnmount() {
        this.setState = () => false;
    }



    onSubmit = async () => {
        const {
            phone,
            address,
            postcode,
            name,
        } = this.state;

        if (name.length == 0) {
            this.setState({ snackopened: true, message: '请输入联系人' });
            return;
        }

        if (phone.length == 0) {
            this.setState({ snackopened: true, message: '请输入手机号' });
            return;
        }

        if (address.length == 0) {
            this.setState({ snackopened: true, message: '请输入地址' });
            return;
        }

        if (postcode.length == 0) {
            this.setState({ snackopened: true, message: '请输入邮政编码' });
            return;
        }

        const { giftid, num, token, uid, channel } = this.props.match.params;

        let result = await Apis.encryptionAddGiftOrderInfo(uid, token, channel, giftid, num, name, phone, address, postcode);
        if (result.code == 200) {
            this.setState({ data: result.data, snackopened: true, message: result.msg })
        } else {
            this.setState({ snackopened: true, message: result.msg })
        }
    }

    onChangeName = (txt) => {
        this.setState({ name: txt })
    }

    onChangePhone = (txt) => {
        this.setState({ phone: txt })
    }

    onChangeAddress = (txt) => {
        this.setState({ address: txt })
    }

    onChangePostCode = (txt) => {
        this.setState({ postcode: txt })
    }

    render() {
        const { classes } = this.props;
        const { name, address, phone, postcode, message, snackopened } = this.state;

        let { nav } = this.props.match.params;

        return (
            <MBack title='添加地址' backgroundColor="#FFF" hideNav={nav}>
                <Grid container direction='column' alignItems='center' className={classes.root}>
                    <Grid container direction='row' alignItems='center' justify='space-between' className={classes.listItem}>
                        <Typography style={{ fontSize: 15, color: '#0D0D0D', width: 100, fontWeight: 'bold' }}>联系人</Typography>
                        <input
                            onChange={event => this.onChangeName(event.target.value)}
                            value={name}
                            type='default'
                            className={classes.textfield}
                            placeholder='名字'
                        />
                    </Grid>
                    <Grid container direction='row' alignItems='center' style={{ paddingLeft: 12, paddingRight: 12 }}>
                        <Grid style={{ backgroundColor: '#E2E2E2', width: '100%', height: 1 }} />
                    </Grid>
                    <Grid container direction='row' alignItems='center' justify='space-between' className={classes.listItem}>
                        <Typography style={{ fontSize: 15, color: '#0D0D0D', width: 100, fontWeight: 'bold' }}>手机号码</Typography>
                        <input
                            onChange={event => this.onChangePhone(event.target.value)}
                            value={phone}
                            type='tel'
                            className={classes.textfield}
                            placeholder='手机号码'
                        />
                    </Grid>
                    <Grid container direction='row' alignItems='center' style={{ paddingLeft: 12, paddingRight: 12 }}>
                        <Grid style={{ backgroundColor: '#E2E2E2', width: '100%', height: 1 }} />
                    </Grid>
                    <Grid container direction='row' alignItems='flex-start' justify='space-between' className={classes.listItem} style={{ height: 100 }}>
                        <Typography style={{ fontSize: 15, color: '#0D0D0D', width: 100, marginTop: 12, fontWeight: 'bold' }}>详细地址</Typography>
                        <textarea
                            onChange={event => this.onChangeAddress(event.target.value)}
                            value={address}
                            type='default'
                            className={classes.textfield1}
                            placeholder='地区以及街道门牌信息'
                        />
                    </Grid>
                    <Grid container direction='row' alignItems='center' style={{ paddingLeft: 12, paddingRight: 12 }}>
                        <Grid style={{ backgroundColor: '#E2E2E2', width: '100%', height: 1 }} />
                    </Grid>
                    <Grid container direction='row' alignItems='center' justify='space-between' className={classes.listItem}>
                        <Typography style={{ fontSize: 15, color: '#0D0D0D', width: 100, fontWeight: 'bold' }}>邮政编码</Typography>
                        <input
                            onChange={event => this.onChangePostCode(event.target.value)}
                            value={postcode}
                            type='tel'
                            className={classes.textfield}
                            placeholder='邮政编码'
                        />
                    </Grid>
                    <Grid container direction='row' alignItems='center' style={{ paddingLeft: 12, paddingRight: 12 }}>
                        <Grid style={{ backgroundColor: '#E2E2E2', width: '100%', height: 1 }} />
                    </Grid>
                    <Grid container direction='row' alignItems='center' style={{ paddingLeft: 12, paddingRight: 12, marginTop: 48 }}>
                        <ButtonBase className={classes.submitButton} onClick={() => this.onSubmit()}>完成</ButtonBase>
                    </Grid>
                    <Grid container direction='row' alignItems='flex-start' style={{ paddingLeft: 12, paddingRight: 12, marginTop: 16 }}>
                        <img src={ICON_ATTION} style={{ width: 15, height: 15 }} />
                        <Typography style={{ fontSize: 12, color: '#FF8A66', flex: 1, marginLeft: 4 }}>注意：确保商品可正确寄送到您的地址上，地址应当详细填写， 只有一次填写机会，完成后会在1～3个工作日发出。</Typography>
                    </Grid>
                </Grid>

                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackopened}
                    onClose={() => this.setState({ snackopened: false })}
                    message={message}
                    autoHideDuration={3000}>
                </Snackbar>
            </MBack>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        marginTop: 24
    },
    listItem: {
        paddingLeft: 12,
        paddingRight: 12,
        height: 50,
    },
    textfield: {
        backgroundColor: 'transparent',
        fontSize: 14,
        height: 30,
        width: '60%',
        border: 'none',
        outline: 'none',
        padding: theme.spacing(0.5, 1, 1, 0),
        flex: 1
    },
    textfield1: {
        backgroundColor: 'transparent',
        fontSize: 14,
        height: 60,
        width: '60%',
        border: 'none',
        outline: 'none',
        padding: theme.spacing(2, 1, 1, 0),
        flex: 1
    },
    submitButton: {
        background: '#007AFF',
        fontSize: 14,
        color: '#FFFFFF',
        width: '100%',
        height: 40,
        borderRadius: 10,
    }
}))(IntegralAddress));